export const SHOW_ERROR = 'SHOW_ERROR';
export const HIDE_ERROR = 'HIDE_ERROR';
export const SHOW_INFO = 'SHOW_INFO';
export const HIDE_INFO = 'HIDE_INFO';

export const SIGN_IN = 'SIGN_IN';
export const LOG_OUT = 'LOG_OUT';
export const UPDATE_USER = 'UPDATE_USER';

export const GET_ALL_JOBS_SUCCESS = 'GET_ALL_JOBS_SUCCESS';
export const GET_JOB_DETAILS_SUCCESS = 'GET_JOB_DETAILS_SUCCESS';
export const CLEAR_JOB_DETAILS = 'CLEAR_JOB_DETAILS';
export const EDIT_JOB_SUCCESS = 'EDIT_JOB_SUCCESS';
export const CREATE_JOB_SUCCESS = 'CREATE_JOB_SUCCESS';
export const POST_JOB_SUCCESS = 'POST_JOB_SUCCESS';
export const CANCEL_JOB_SUCCESS = 'CANCEL_JOB_SUCCESS';
export const APPROVE_JOB_SUCCESS = 'APPROVE_JOB_SUCCESS';

export const GET_COST_PAY_RATE_SUCCESS = 'GET_COST_PAY_RATE_SUCCESS';
export const GET_COST_PAY_RATE_START = 'GET_COST_PAY_RATE_START';
export const GET_COST_PAY_RATE_ERROR = 'GET_COST_PAY_RATE_ERROR';

export const GET_EVENT_SCHEDULE_SUCCESS = 'GET_EVENT_SCHEDULE_SUCCESS';
export const GET_EVENTS_SUCCESS = 'GET_EVENTS_SUCCESS';
export const GET_EVENT_DETAILS_SUCCESS = 'GET_EVENT_DETAILS_SUCCESS';
export const EDIT_EVENT_SUCCESS = 'EDIT_EVENT_SUCCESS';
export const CREATE_EVENT_SUCCESS = 'CREATE_EVENT_SUCCESS';
export const SEARCH_EVENTS_BY_NAME_SUCCESS = 'SEARCH_EVENTS_BY_NAME_SUCCESS';

export const GET_ALL_DRESS_CODES_SUCCESS = 'GET_ALL_DRESS_CODES_SUCCESS';

export const GET_ALL_SKILLS_SUCCESS = 'GET_ALL_SKILLS_SUCCESS';
export const GET_SKILL_LEVELS_SUCCESS = 'GET_SKILL_LEVELS_SUCCESS';
export const GET_WORKER_SKILLS_SUCCESS = 'GET_WORKER_SKILLS_SUCCESS';

export const GET_JOB_CATEGORIES_SUCCESS = 'GET_JOB_CATEGORIES_SUCCESS';

export const GET_LOCATIONS_LIST_SUCCESS = 'GET_LOCATIONS_LIST_SUCCESS';
export const SET_COMPANY_LOCATIONS = 'SET_COMPANY_LOCATIONS';
export const ADD_COMPANY_LOCATION = 'ADD_COMPANY_LOCATION';

export const GET_LANGUAGES_LIST_SUCCESS = 'GET_LANGUAGES_LIST_SUCCESS';

export const REFERENCE_REQUEST = 'REFERENCE_REQUEST';
export const REFERENCE_SENT = 'REFERENCE_SENT';

export const EDIT_JOB_WORKER_SUCCESS = 'EDIT_JOB_WORKER_SUCCESS';
export const ADD_JOB_WORKER_SUCCESS = 'ADD_JOB_WORKER_SUCCESS';

export const SEARCH_USERS_SUCCESS = 'SEARCH_USERS_SUCCESS';
export const SEARCH_WORKERS_SUCCESS = 'SEARCH_WORKERS_SUCCESS';
export const SET_WORKERS_PREDICTIONS_LIST = 'SET_WORKERS_PREDICTIONS_LIST';
export const CLEAR_WORKERS_PREDICTIONS_LIST = 'CLEAR_WORKERS_PREDICTIONS_LIST';
export const SEARCH_EMPLOYERS_SUCCESS = 'SEARCH_EMPLOYERS_SUCCESS';
export const CLEAR_EMPLOYERS_PREDICTIONS_LIST = 'CLEAR_EMPLOYERS_PREDICTIONS_LIST';

export const TOGGLE_ASIDE_MENU = 'TOGGLE_ASIDE_MENU';
export const CLOSE_ASIDE_MENU = 'CLOSE_ASIDE_MENU';
export const HIDE_DESKTOP_ASIDE_MENU = 'HIDE_DESKTOP_ASIDE_MENU';
export const SHOW_DESKTOP_ASIDE_MENU = 'SHOW_DESKTOP_ASIDE_MENU';

export const GET_ALL_WORKERS_SUCCESS = 'GET_ALL_WORKERS_SUCCESS';
export const GET_WORKER_DETAILS_SUCCESS = 'GET_WORKER_DETAILS_SUCCESS';
export const CLEAR_WORKER_DETAILS = 'CLEAR_WORKER_DETAILS';
export const GET_WORKER_JOBS_SUCCESS = 'GET_WORKER_JOBS_SUCCESS';
export const GET_WORKER_JOBS_COMPLETED_SUCCESS = 'GET_WORKER_JOBS_COMPLETED_SUCCESS';

export const APPROVE_PROSPECT_SUCCESS = 'APPROVE_PROSPECT_SUCCESS';
export const CHECK_PROSPECT_SUCCESS = 'CHECK_PROSPECT_SUCCESS';
export const CONVERT_PROSPECT_SUCCESS = 'CONVERT_PROSPECT_SUCCESS';
export const CALLBACK_PROSPECT_SUCCESS = 'CALLBACK_PROSPECT_SUCCESS';
export const DENY_PROSPECT_SUCCESS = 'DENY_PROSPECT_SUCCESS';
export const GET_ALL_PROSPECTS_SUCCESS = 'GET_ALL_PROSPECTS_SUCCESS';
export const GET_PROSPECT_DETAILS_SUCCESS = 'GET_PROSPECT_DETAILS_SUCCESS';
export const CLEAR_PROSPECT_DETAILS = 'CLEAR_PROSPECT_DETAILS';
export const GET_PROSPECT_JOBS_SUCCESS = 'GET_PROSPECT_JOBS_SUCCESS';
export const UPDATE_PROSPECT_SUCCESS = 'UPDATE_PROSPECT_SUCCESS';

export const GET_ALL_EMPLOYERS_SUCCESS = 'GET_ALL_EMPLOYERS_SUCCESS';
export const GET_EMPLOYER_DETAILS_SUCCESS = 'GET_EMPLOYER_DETAILS_SUCCESS';
export const CLEAR_EMPLOYER_DETAILS = 'CLEAR_EMPLOYER_DETAILS';
export const GET_COMPANY_CONTACTS = 'GET_COMPANY_CONTACTS';
export const GET_COMPANY_DEPARTMENTS_SUCCESS = 'GET_COMPANY_DEPARTMENTS_SUCCESS';
export const SEARCH_COMPANIES_BY_NAME_SUCCESS = 'SEARCH_COMPANIES_BY_NAME_SUCCESS';
export const SEARCH_COMPANIES_BY_NAME_CLEAR_RESULTS = 'SEARCH_COMPANIES_BY_NAME_CLEAR_RESULTS';
export const GET_COMPANY_EVENTS_SUCCESS = 'GET_COMPANY_EVENTS_SUCCESS';
export const GET_COMPANY_PAYMENT_SUCCESS = 'GET_COMPANY_PAYMENT_SUCCESS';
export const CLEAR_COMPANY_DETAILS = 'CLEAR_COMPANY_DETAILS';

export const GET_LTA_WORKERS_SUCCESS = 'GET_LTA_WORKERS_SUCCESS';
export const CLEAR_LTA_WORKERS = 'CLEAR_LTA_WORKERS';
export const GET_FAV_AND_BLOCKS_SUCCESS = 'GET_FAV_AND_BLOCKS_SUCCESS';
export const CLEAR_FAV_AND_BLOCKS = 'CLEAR_FAV_AND_BLOCKS';

export const POST_FAV_BLOCK_WORKER_SUCCESS = 'POST_FAV_BLOCK_WORKER_SUCCESS';

export const PUT_FAV_BLOCK_WORKER_SUCCESS = 'PUT_FAV_BLOCK_WORKER_SUCCESS';

export const DELETE_FAV_BLOCK_WORKER_SUCCESS = 'DELETE_FAV_BLOCK_WORKER_SUCCESS';

export const GET_ALL_COMPANIES_SUCCESS = 'GET_ALL_COMPANIES_SUCCESS';
export const GET_COMPANY_DETAILS_SUCCESS = 'GET_COMPANY_DETAILS_SUCCESS';
export const EDIT_COMPANY_SUCCESS = 'EDIT_COMPANY_SUCCESS';
export const ADD_CUSTOM_RATE_SUCCESS = 'ADD_CUSTOM_RATE_SUCCESS';
export const DELETE_CUSTOM_RATE_SUCCESS = 'DELETE_CUSTOM_RATE_SUCCESS';

export const GET_PAYROLL_RUNS_SUCCESS = 'GET_PAYROLL_RUNS_SUCCESS';

export const GET_DASHBOARD_SUCCESS = 'GET_DASHBOARD_SUCCESS';

export const GET_ADMINS_LIST_SUCCESS = 'GET_ADMINS_LIST_SUCCESS';

export const GET_INTERVIEWS_START = 'GET_INTERVIEWS_START';
export const GET_INTERVIEWS_SUCCESS = 'GET_INTERVIEWS_SUCCESS';
export const GET_INTERVIEWS_ERROR = 'GET_INTERVIEWS_ERROR';
export const GET_TIMESLOTS_SUCCESS = 'GET_TIMESLOTS_SUCCESS';

export const GET_CONVERSATIONS_START = 'GET_CONVERSATIONS_START';
export const GET_CONVERSATIONS_SUCCESS = 'GET_CONVERSATIONS_SUCCESS';
export const GET_CONVERSATIONS_ERROR = 'GET_CONVERSATIONS_ERROR';

export const SEND_CONVERSATIONS_START = 'SEND_CONVERSATIONS_START';
export const SEND_CONVERSATIONS_SUCCESS = 'SEND_CONVERSATIONS_SUCCESS';
export const SEND_CONVERSATIONS_ERROR = 'SEND_CONVERSATIONS_ERROR';

export const CLEAR_CONVERSATIONS_HISTORY = 'CLEAR_CONVERSATIONS_HISTORY';

export const UPDATE_JOB_CONVERSATION_ID = 'UPDATE_JOB_CONVERSATION_ID';

export const GET_MESSAGES_START = 'GET_MESSAGES_START';
export const GET_MESSAGES_SUCCESS = 'GET_MESSAGES_SUCCESS';
export const GET_MESSAGES_ERROR = 'GET_MESSAGES_ERROR';

export const SET_MESSAGES = 'SET_MESSAGES';
export const PUSH_SINGLE_MESSAGE = 'PUSH_SINGLE_MESSAGE';

export const SEND_JOB_NOTIFICATION = 'SEND_JOB_NOTIFICATION';

export const SEND_MESSAGE_START = 'SEND_MESSAGE_START';
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_ERROR = 'SEND_MESSAGE_ERROR';

export const GET_UNREAD_MESSAGES_QUANTITY = 'GET_UNREAD_MESSAGES_QUANTITY';
export const INCREMENT_UNREAD_COUNT = 'INCREMENT_UNREAD_COUNT';

export const UI_SHOW_ALERT = 'UI_SHOW_ALERT';
export const UI_HIDE_ALERT = 'UI_HIDE_ALERT';
export const UI_SHOW_CONFIRM = 'UI_SHOW_CONFIRM';
export const UI_HIDE_CONFIRM = 'UI_HIDE_CONFIRM';

export const GET_WORKER_QUICK_VIEW_START = 'GET_WORKER_QUICK_VIEW_START';
export const GET_WORKER_QUICK_VIEW_ERROR = 'GET_WORKER_QUICK_VIEW_ERROR';
export const GET_WORKER_QUICK_VIEW_SUCCESS = 'GET_WORKER_QUICK_VIEW_SUCCESS';
export const CLEAR_WORKER_QUICK_VIEW = 'CLEAR_WORKER_QUICK_VIEW';

export const GET_ORIENTATION_LOCATIONS_SUCCESS = 'GET_ORIENTATION_LOCATIONS_SUCCESS';
export const GET_ORIENTATIONS_SUCCESS = 'GET_ORIENTATIONS_SUCCESS';
export const GET_ORIENTATION_DETAILS_SUCCESS = 'GET_ORIENTATION_DETAILS_SUCCESS';

export const GET_ASSESSMENTS_SUCCESS = 'GET_ASSESSMENTS_SUCCESS';



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js